'use strict';
import { compose, createStore, applyMiddleware } from 'redux';
import keyMirror from 'keymirror';
import { combineReducers } from 'redux-immutablejs';
import Immutable from 'immutable';
import thunkMiddleware from 'redux-thunk';
import {reducer as reduxFormReducer} from 'redux-form';
import reqwest from 'reqwest';

/*
    ActionTypes
 */
const ActionTypes = keyMirror({
    handleSubmit: null,
    handleSubmitSuccess: null,
    handleSubmitError: null,
});


/*
    Actions
 */
const Actions = {
    handleSubmit: (payload) => {
        return (dispatch, getState) => {
            dispatch({type: ActionTypes.handleSubmit});
            payload.csrfmiddlewaretoken = window.csrf_token;
            return reqwest({
                method: 'post',
                url: '/api/contact',
                data: payload
            }).then(json => dispatch({
                type: ActionTypes.handleSubmitSuccess,
                payload: json
            })).catch(err => dispatch({
                type: ActionTypes.handleSubmitError,
                payload: err
            }));
        };
    }
};

/*
    Form Reducer
 */
const FormReducer = (state = Immutable.fromJS({}), action) => {
    return Immutable.fromJS(reduxFormReducer(state.toJS(), action));
};


/*
    Reducer
 */
const ContactReducer = (state = Immutable.fromJS({}), action) => {
    switch (action.type) {

    case ActionTypes.handleSubmit:
        state = state.set('loading', true);
        break;

    case ActionTypes.handleSubmitSuccess:
        state = state.set('success', true);
        break;

    case ActionTypes.handleSubmitError:
        state = state.set('error', true);
        break;

    default:
        state = state;
        break;

    }

    return state;
};


/**
 * creates the store by combining
 * the reducer with the initial state
 * @param  {[type]} initialState [description]
 * @return {[type]}              [description]
 */
const configureStore = function configureStore() {
    const Reducer = combineReducers({
        form: FormReducer,
        contact: ContactReducer
    });

    var finalCreateStore = compose(applyMiddleware(thunkMiddleware))(createStore);
    let state = Immutable.fromJS({
        contact: {
            loading: false,
            success: false,
            error: false
        }
    });

    let store = finalCreateStore(Reducer, state);
    return store;
};


module.exports = {
    configureStore: configureStore,
    Actions: Actions
};



// WEBPACK FOOTER //
// ./static/app/contact/state.js